'use strict';
window.onpopstate = function(e) {
    console.log("Page reload");
    location.reload(true);
};


const TradePriceChanges = (props) =>{
    const {
        version,state
    }= props;


    var APIEndPoint = window.location.origin;
    const queryParams = new URLSearchParams(window.location.search);

    var p = 1;
    var pageNo = queryParams.get('page');
    if(pageNo!== '' && pageNo !==null){
        p = pageNo;
    }

    //showing per page filter 
    var perPage = 24;
    var pr = queryParams.get('items');
    var pageArray = ['24','48','96'];

    var totalResults=0;

    if(pr!== '' && pr !==null && pr!== undefined && pr!== 0){
        if(pageArray.includes(pr)){
            if(pr == '24' || pr == '48' || pr == '96' ){
                perPage = pr;  
            }    
        }
    }

    //mostrelevent filter
    var mostreleventfilter= 'supplier-asc';
    var mostreleventURL = queryParams.get('sort');
   
    if(mostreleventURL == 'supplier-asc'){
        mostreleventfilter = 'supplier-asc';
    }else if(mostreleventURL == 'supplier-desc'){
        mostreleventfilter = 'supplier-desc';
    }else if(mostreleventURL == 'effective_date'){
        mostreleventfilter = 'effective_date';
    }

    var sortByAlpha= 'all';
    var sortByAlphaArray = ['all','a','b','c','d','e','f','g','h','i','j','k','l','m','n','o','p','q','r','s','t','u','v','w','x','y','z','#'];
    var sortByAlphaURL = queryParams.get('sortbyalpha');
    if(sortByAlphaURL == 'hash'){
        sortByAlphaURL = '#';
    }
    if(sortByAlphaURL !== sortByAlpha && sortByAlphaURL !=='' && sortByAlphaURL !==null && sortByAlphaURL !== undefined && sortByAlphaArray.includes(sortByAlphaURL)){
        sortByAlpha = sortByAlphaURL;
    }

    var listsData;
    const [filterMostRelevent, setFilterMostRelevent] = React.useState(mostreleventfilter);
    const [filterSortByAlpha, setFilterSortByAlpha] = React.useState(sortByAlpha);
    const [filterShowing, setFilterShowing] = React.useState(perPage); 
    const [currentPage, setCurrentPage] = React.useState(p);

    // response
    const [responseData, setResponseData] = React.useState(null);

    // loader
    const [showLoader, setShowLoader] = React.useState(false);
    const [totalRecordsCount, setTotalRecordsCount] = React.useState(0);
    const [error, setError] = React.useState(null);
    const [isLoaded, setIsLoaded] = React.useState(false);
    function _AntiForgeryToken(id) {
        $.ajax({
            url: "/login/RefreshToken",
            type: "GET",
            dataType: "json",
            beforeSend: function (xhr) {
                xhr.setRequestHeader('Content-Type', 'application/json');
            },
            success: function (data) {
                //console.log(data);
            },
            complete: function (data) {
                //console.log("Hello", data);
                $(id).html(data.responseText);
                // Set our complete callback, 
            },
            error: function (e) {
                //alert("error");
            }
        });
    }
    React.useEffect(() => {
        setShowLoader(true);
        var pageChangeURL = '';
        var tradepricechangesDataResponseCode = '';
        var pageAPI = '';
        var sizeAPI = '';
        var sortAPI = '';
        var sortAlphaAPI = '';
       
        const apiCallToGettradepricechanges = () =>{
            setShowLoader(true);
            pageChangeURL = '';
            if(filterShowing !=='' && filterShowing >0){
                if(filterShowing != 24){
                    pageChangeURL +='&items='+filterShowing;
                }
                sizeAPI = filterShowing;
            }
            if(currentPage !==''){
                if(currentPage != 1){
                    pageChangeURL +='&page='+currentPage;
                }
                pageAPI = currentPage;
            }
            if(filterMostRelevent !== '' && filterMostRelevent!==null){
                var relevantURL = '';
                if(filterMostRelevent !== '' && filterMostRelevent!==null){
                    if(filterMostRelevent == 'supplier-asc'){
                        relevantURL = '&sort=supplier-asc';
                        relevantURL = '';
                    }else if(filterMostRelevent == 'supplier-desc'){
                        relevantURL = '&sort=supplier-desc';
                    }else if(filterMostRelevent == 'effective_date'){
                        relevantURL = '&sort=effective_date';
                    }
                    sortAPI = filterMostRelevent;     
                }
                pageChangeURL+= relevantURL;
            }

            if(filterSortByAlpha !== '' && filterSortByAlpha!==null){
                var relevantAlphaURL = '';
                if(filterSortByAlpha !== '' && filterSortByAlpha!==null){
                    if(filterSortByAlpha == 'all'){
                        relevantAlphaURL = '';
                        sortAlphaAPI = '1';
                    }else if(filterSortByAlpha == '#'){
                        relevantAlphaURL = '&sortbyalpha=hash';
                        sortAlphaAPI = filterSortByAlpha;
                    }else{
                        relevantAlphaURL = '&sortbyalpha='+filterSortByAlpha;
                        sortAlphaAPI = filterSortByAlpha;
                    }
                     
                }
                pageChangeURL+= relevantAlphaURL;
            }
               
            if(pageChangeURL != '')
            {
              pageChangeURL = "?" + pageChangeURL.substring(1);
            }
    
    
            history.pushState({}, null, window.location.origin+window.location.pathname+pageChangeURL);
    
            var params= '{"Page":{"current":'+pageAPI+',"size":'+sizeAPI+'}, "SortBy": "'+sortAPI+'","SortByAlpha":"'+sortAlphaAPI+'"}';
            console.log(params);
            fetch(APIEndPoint +'/api/TradePrice', {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                    "RequestVerificationToken": $("#checkloginApi [name='__RequestVerificationToken']").val()
                },
                body: params,
            }).then(results => {
              tradepricechangesDataResponseCode = results.status;
                if(tradepricechangesDataResponseCode == 204){
                    window.location.href = window.location.origin+'/404';  
                }
                return results.json();
            }).then((data) => { 
                _AntiForgeryToken("#checkloginApi");
                if(data){
                    setIsLoaded(true);
                    if(data.hasOwnProperty('errors')){
                        setError(data.errors);
                        setShowLoader(false);
                    }
                    else{
                        setResponseData(data);
                        if(data.hasOwnProperty('all_results')){
                            setTotalRecordsCount(data.all_results);
                        }
                        setShowLoader(false);
                    } 
                }else{
                    console.log("Some thing went Wrong...");
                    setShowLoader(false);
                }
            },
            (error)=>{
                console.log("error================", error); 
                _AntiForgeryToken("#checkloginApi");
                setIsLoaded(true);
                setError(error);
                setShowLoader(false);
            })
        }
        
        //const timeout = setTimeout(() => {
          apiCallToGettradepricechanges(); 
        //}, 1000)
        //return () => clearTimeout(timeout);
    
    }, [filterMostRelevent,filterShowing,currentPage,filterSortByAlpha]);


    const getTotalResult = () =>{
        if(responseData !== null ){
            if(responseData.hasOwnProperty('total_results')){
                totalResults = responseData.total_results;
            }
        }
        return totalResults;
    }
      //getlisting
      const getListingData = () => {
        if(responseData !== null ){
            listsData = responseData.results;
            if(listsData.length>0){
                return(
                    <div className="trade-price-list">
                        {listsData.length>0 ? 
                            listsData.map((result,pIndex)=>{

                                var date1 = new Date(result.effective_date);
                                var date = new Date(date1.toISOString());
                                var effective_date =`${
                                    date.getDate().toString().padStart(2, '0')}/${
                                    (date.getMonth()+1).toString().padStart(2, '0')}/${
                                    date.getFullYear().toString().padStart(4, '0')}`;

                                return(
                                    <div className="trade-row flex" key={pIndex}>
                                        <div className="col">
                                            <span>Supplier</span>
                                            {result.supplier!==''?
                                                    result.download_uri!==''?
                                                        <a href={result.download_uri.includes('~')?
                                                            APIEndPoint+result.download_uri.replace('~', '')
                                                            :result.download_uri
                                                        } target="_blank">{result.supplier}</a>
                                                    :
                                                        <a href="#" onClick={e => {e.preventDefault()}}>{result.supplier}</a>                                                     
                                                :
                                                <a href="#" style={{visibility:"hidden"}}></a>}
                                        </div>
                                        <div className="col">
                                            <span>Product Group</span>
                                            {result.product_group!==''?<label>{result.product_group}</label>:<label></label>}
                                        </div>
                                        <div className="col">
                                            <span>Price Change</span>
                                            {result.price_change!==''?<label>{result.price_change}</label>:<label></label>}
                                        </div>
                                        <div className="col">
                                            <span>Effective Date</span>
                                            {result.effective_date!==''&&result.effective_date!==null?<label>{effective_date}</label>:<label></label>}
                                        </div>
                                        <div className="col">
                                            {result.download_uri!==''?<a href={result.download_uri.includes('~')?
                                                    APIEndPoint+result.download_uri.replace('~', '')
                                                    :result.download_uri
                                                } className="btn" target="_blank">Details</a>:<a href="#" className="btn" style={{visibility:"hidden"}}>Details</a>}
                                        </div>
                                    </div>
                                );
                            })
                        :null}
                   </div>
                );
            }else{
                //return false;
                return(
                    <div className="trade-price-list">
                        <h2>No data found.</h2>
                    </div>);
            }
        }
    }

    //most relavent
    const getMostRelevant= (props) =>{

        $('.sortby').select2({
            minimumResultsForSearch: Infinity,
            width: 'style',
        }).on("select2:selecting", function (e) {
            handleMostReleventChangeSelect2(e.params.args.data.id);
        });
    
        function handleMostReleventChangeSelect2(value) {
            setCurrentPage(1);
            setFilterMostRelevent(value);
        }
        function handleMostReleventChange(event) {
            setCurrentPage(1);
            setFilterMostRelevent(event.target.value);
        }
        return (
            <select id="tradepricechanges-sorting" className="sortby custom-select" value={filterMostRelevent} onChange={handleMostReleventChange}>
                <option value="supplier-asc">Supplier (A-Z)</option>
                <option value="supplier-desc">Supplier (Z-A)</option>
                <option value="effective_date">Effective Date</option>
            </select>
        )
    }

    const getSortByAlpha = (props) =>{
        function handleSortByAlphaChange(alpha) {
            setCurrentPage(1);
            setFilterSortByAlpha(alpha);
        }
        
        return(
            <div className="letter-filter">
                <label>Show By:</label>
                <div className="flex">
                    {sortByAlphaArray.map((al,i)=>{
                        return(
                            <a href="#" className={`${filterSortByAlpha==al?'selected':''}`} key={i} onClick={e => {e.preventDefault(),handleSortByAlphaChange(al)}}>{al.toUpperCase()}</a>
                        )
                    })}
                </div>
            </div>
        );
    }
    
    // showing per page
    const getShowing = (props) =>{

        $('.showing').select2({
            minimumResultsForSearch: Infinity,
            width: 'style',
        }).on("select2:selecting", function (e) {
            handleShowingChangeSelect2(e.params.args.data.id);
        });
        
        function handleShowingChangeSelect2(value) {
            setCurrentPage(1);
            setFilterShowing(value);
        }
    
        function handleShowingChange(event) {
            setCurrentPage(1);
            setFilterShowing(event.target.value);  
        }
        if(getTotalResult()>24){

            return(
            <div className="showingParent">
                <select id="tradepricechanges-parpageitems" className="showing custom-select" value={filterShowing} onChange={handleShowingChange}>
                    <option  value="24">Show 24</option>
                    <option  value="48">Show 48</option>
                    <option  value="96">Show 96</option>
                </select>
            </div>
        );
        }else{
            return false;
        }
        
    }
    // [pagination start]
    const Pagination = (props) => {
        const {
        onPageChange,
        totalCount,
        siblingCount = 1,
        currentPage,
        pageSize,
        className
        } = props;
  
        const paginationRange = usePagination({
        currentPage,
        totalCount,
        siblingCount,
        pageSize
        });
        var key = 0; 
        if (currentPage == 0 || paginationRange.length < 2) {
        return null;
        }
    
        const onNext = () => {
        onPageChange(parseInt(currentPage) + 1);
        };
    
        const onPrevious = () => {
        onPageChange(parseInt(currentPage) - 1);
        };

        let lastPage = paginationRange[paginationRange.length - 1];
        return (
            <ul className={`${className?className:''}`}>
                <li className={`previous ${currentPage == 1?'disabled':''}`}  style={{pointerEvents:currentPage == 1?'none':'auto'}} onClick={onPrevious}>
                    <a id="tradepricechanges-page-prevoius" href='#' onClick={e => e.preventDefault()}></a>
                </li>
                {paginationRange.map(pageNumber => {
                if (pageNumber == '...') {
                    key++;
                    return <li key={`dot`+key} className="dots"><a href='#' onClick={e => e.preventDefault()}>&#8230;</a></li>;
                }
                return (
                    <li key={pageNumber} className={` ${pageNumber == currentPage?'active':''}`} onClick={() => onPageChange(pageNumber)}>
                    <a id={"tradepricechanges-page-"+pageNumber} href='#' onClick={e => e.preventDefault()}>{pageNumber}</a>
                    </li>
                );
                })}
                <li className={`next ${currentPage == lastPage?'disabled':''}`} style={{pointerEvents:currentPage == lastPage?'none':'auto'}} onClick={onNext}>
                    <a id="tradepricechanges-page-next" href='#' onClick={e => e.preventDefault()}></a>
                </li>
            </ul>
        );
    };
    
    const range = (start, end) => {
    let length = end - start + 1;
    
    return Array.from({ length }, (_, idx) => idx + start); 
    };  
    const usePagination = ({
        totalCount,
        pageSize,
        siblingCount = 1,
        currentPage
    }) => {
        
        const paginationRange = React.useMemo(() => {
            const totalPageCount = Math.ceil(totalCount / pageSize);
    
            const totalPageNumbers = siblingCount + 5;
    
            if (totalPageNumbers >= totalPageCount) {
            return range(1, totalPageCount);
            }
            
            const leftSiblingIndex = Math.max(currentPage - siblingCount, 1);
            const rightSiblingIndex = Math.min(
            parseInt(currentPage)+parseInt(siblingCount),
            totalPageCount
            );
            
            var shouldShowLeftDots = leftSiblingIndex > 2;
            if($(window).width() <= 480){
                shouldShowLeftDots = leftSiblingIndex >= 2;
            }
            const shouldShowRightDots = rightSiblingIndex < totalPageCount - 2;
        
            const firstPageIndex = 1;
            const lastPageIndex = totalPageCount;
        
           
            if (!shouldShowLeftDots && shouldShowRightDots) {
            let sCount = 3;
            let rCount = 2; 
            if($(window).width() <= 480){
                rCount = 0;
                sCount = 2;
            }
            let leftItemCount = sCount + rCount * siblingCount;
            let leftRange = range(1, leftItemCount);
            let endRange = totalPageCount>0 ? [parseInt(totalPageCount-1),parseInt(totalPageCount)]: [parseInt(totalPageCount)];
            
                if($(window).width() <= 480){
                    return [...leftRange, '...', ...endRange];
                }else{
                    return [...leftRange, '...', totalPageCount];
                }
            }
    
            if (shouldShowLeftDots && !shouldShowRightDots) {
            let rCount = 2; 
            if($(window).width() <= 480){
                rCount = 0;
            }
            let rightItemCount = 3 + rCount * siblingCount;
            let rightRange = range(
                totalPageCount - rightItemCount + 1,
                totalPageCount
            );
            return [firstPageIndex, '...', ...rightRange];
            }
    
            if (shouldShowLeftDots && shouldShowRightDots) {
            let middleRange = range(leftSiblingIndex, rightSiblingIndex);
            let middleRangeResponsive = [parseInt(currentPage)];
            if($(window).width() <= 480){
                return [firstPageIndex, '...', ...middleRangeResponsive, '...', lastPageIndex];
            }else{
                return [firstPageIndex, '...', ...middleRange, '...', lastPageIndex];
            }
            }
        }, [totalCount, pageSize, siblingCount, currentPage]);
    
        return paginationRange;
    };
  // [pagination end] 


if (error) {
    return(
        <div className="product-not-found">
            <h2 className="error">
                Sorry, the page you were looking for is not responding.
            </h2>
            <br />
            <h2 className="error">
                To get you re-connected, try browsing our{" "}
                <a href={`${window.location.origin}`}>return home</a>.
            </h2>
        </div>
    );

}else if (!isLoaded) {
    return (
      <div id="middys-overlay" style={{ display: showLoader == true ? "" : "none" }}>
        <div className="middys-spinner">
          <span className="middys-prod-spinner"></span>
        </div>
      </div>
    );
} else {
    return(
        <React.Fragment>
            <div id="middys-overlay" style={{display:showLoader==true?"":"none"}}>
              <div className="middys-spinner">
                  <span className="middys-prod-spinner"></span>
              </div>
            </div>
            <div className="sort-wrap flex-end-space-between">
                {getSortByAlpha()}
                {getMostRelevant()}
            </div>
            {getListingData()}
            <div className="page-footer flex-center-space-between">
                {getShowing()}
                <Pagination
                    className="pagination"
                    currentPage={currentPage}
                    totalCount={getTotalResult()}
                    pageSize={filterShowing}
                    onPageChange={page => {
                    setCurrentPage(page)
                    ,window.scrollTo(0, 0)
                }}
            />
            </div>
        </React.Fragment>
    );
}
}


ReactDOM.render(<TradePriceChanges />, document.querySelector("#TradePriceChanges"));